import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import FullScreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import {LOOK_OPENED_TYPES} from "../../core/constants";
import {setLookDemoPointsClicked, setLookOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const GroheMenuButton = (props) => {

  const {intl, visualizersLoadedLength, lookOpened, setLookOpened, setLookPageOpened, lookPageOpened, topButtonClick,
    setLookDemoPointsClicked} = props;

  const menuButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsMenu);
    if (!visualizersLoadedLength) {
      return false
    }

    if (lookOpened || lookPageOpened) {
      topButtonClick();
      return;
    }

    setLookOpened(LOOK_OPENED_TYPES.edit);
    setLookDemoPointsClicked(true);
    if (!lookPageOpened) {
      setTimeout(() => {
        setLookPageOpened(ROUTES.category);
      }, 0)
    }
  }

  return (
    <div className={"gm-buttons__button"}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.menu"})}
                  className="look-icon look-icon--small1 look-icon--grohe"
                  onClick={menuButtonClick}>
        {lookOpened ? <FullScreenIcon/> : <FullscreenExitIcon/>}
      </IconButton>
    </div>
  )
};

GroheMenuButton.propTypes = {
  topButtonClick: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {lookOpened, lookPageOpened} = store.lookState;
  return {
    lookOpened,
    lookPageOpened,
    visualizersLoadedLength: visualizersLoaded.length
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookPageOpened,
  setLookDemoPointsClicked,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheMenuButton)
)
